import React from "react";
import { Star, Quote } from "lucide-react";
import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "Well, that was painless. I can see making the move to Host1Help1 was a smart decision! Thanks for your help.",
    name: "Suzanne",
    company: "A1WeldingINC.com",
  },
  {
    quote:
      "Doug's Company is reliable, creative, and affordable in Web Hosting, and Web Design. I highly recommend.",
    name: "Troy Muljat",
    company: "Muljat.com",
  },
  {
    quote:
      "We have worked with Doug in web development and hosting for several years. We trust his experience and expertise when it comes to hosting the mtbaker.us website. Doug (Host1Help1) has been our high-level phone-a-friend and has assisted us with many things including server migrations and optimizing our website's performance.",
    name: "Mike Trowbridge",
    company: "Mt Baker Ski Area",
  },
  {
    quote:
      "SO glad to move our website forward. It took 6 months to get here with the other company, but once you stepped into the loop, it went lightning fast!! Thank you!",
    name: "Kristi",
    company: "SeanHumphreyHouse.org",
  },
  {
    quote:
      "Host1Help1 has been a solid company to work with and is run by terrific people who provide a high level of excellence. A big recommendation for anyone needing hosting services.",
    name: "Lionel Thompson",
    company: "AvlonFinance.com",
  },
  {
    quote:
      "Doug took over our website and he stabilized it and exploded it in so many ways - he redesigned it, streamlined it, added professional content and our web traffic increased off the charts!",
    name: "Dave Irby, President",
    company: "SurgeSoccer.org",
  },
  {
    quote:
      "As a non-profit, one of the reasons I switched hosting providers years ago was for support. Doug (Host1Help1) has provided exceptional and timely support for our organization for several years. This has included rebuilding and optimizing our website & setting up Google Suite for Non-Profits.",
    name: "Darrell G. - Mount of Olives",
    company: "Missions-Network.org",
  },
  {
    quote:
      "Doug, at Host1Help1.com, took the daunting task of creating a website and took us from concept and ideas to a final product in a timely manner. He listened and always responded with patience as we developed our website. Doug is very responsive to the challenges we experience and quick to find solutions. Hosting with host1help1 is reliable and gives us one more opportunity to give back to the larger community.",
    name: "Sharon Aller",
    company: "ResetFamilies.org",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-14 sm:mb-20"
        >
          <p className="text-sm font-semibold uppercase tracking-widest text-primary mb-3">
            Testimonials
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight">
            What our Customers Say
          </h2>
        </motion.div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="break-inside-avoid bg-card border border-border/50 rounded-2xl p-6 sm:p-8 hover:border-primary/15 hover:shadow-md transition-all duration-300"
            >
              <Quote className="w-8 h-8 text-primary/15 mb-4" />
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star
                    key={j}
                    className="w-4 h-4 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>
              <p className="text-muted-foreground leading-relaxed mb-6 text-sm sm:text-base">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary/[0.08] flex items-center justify-center">
                  <span className="text-sm font-bold text-primary">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold">{t.name}</p>
                  <p className="text-xs text-muted-foreground">{t.company}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}